__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@coconutuk/coconut-accountant-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("coconut-shared-libraries", "1.0.0", () => (Promise.all([__webpack_require__.e(5348), __webpack_require__.e(4124), __webpack_require__.e(5842), __webpack_require__.e(6433), __webpack_require__.e(3617), __webpack_require__.e(9903), __webpack_require__.e(4169), __webpack_require__.e(3884), __webpack_require__.e(2785), __webpack_require__.e(2335)]).then(() => (() => (__webpack_require__(89903))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(3884), __webpack_require__.e(2123)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-hot-toast", "2.6.0", () => (Promise.all([__webpack_require__.e(3884), __webpack_require__.e(3768)]).then(() => (() => (__webpack_require__(23768))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(9074), __webpack_require__.e(3884), __webpack_require__.e(5876)]).then(() => (() => (__webpack_require__(29074))))));
			register("react", "17.0.2", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(8747), __webpack_require__.e(3884), __webpack_require__.e(219)]).then(() => (() => (__webpack_require__(88747))))));
			initExternal(54269);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};